// frontend/src/pages/NotFound.js

import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <motion.div
      className="flex flex-col items-center justify-center h-full py-20"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="text-6xl font-heading text-primary mb-4">404</h1>
      <p className="text-xl font-body mb-6">Seite nicht gefunden</p>
      <Link
        to="/"
        className="bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 transition"
      >
        Zur Startseite
      </Link>
    </motion.div>
  );
};

export default NotFound;
